import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const userSingleOverviewTableHeadings = [
	{
		data: 'coursesEnrolled',
		title: sprintf(reportingApiSetup.localizedStrings.tablesColumnsCoursesEnrolled, reportingApiSetup.learnDashLabels.courses)
	},
	{ data: 'notStarted', title: ls('Not Started') },
	{ data: 'inProgress', title: ls('In Progress') },
	{ data: 'completed', title: ls('Completed') }
];

const userSingleOverviewTableData = function(userID) {
	var tableData = [];
	var enrolled = 0;
	var notStarted = 0;
	var inProgress = 0;
	var completed = 0;

	tableData.push({
		coursesEnrolled: enrolled,
		notStarted: notStarted,
		inProgress: inProgress,
		completed: completed
	});
	return tableData;
};

export {
	userSingleOverviewTableHeadings,
	userSingleOverviewTableData
};
